// UX45: social-proof activity chip.
//
// Small badge that lives in the card-meta row and surfaces "this poll
// is alive right now." Three states, picked in priority order:
//   • trending (sudden spike in the last hour)        → 🔥 Trending
//   • >= 5 votes in the last hour                     → ⚡ N voting now
//   • >= 10 votes in the last 24h                     → 💬 N today
// Below the 24h floor the chip is suppressed entirely — half-empty
// numbers would read as "no one's here" and do the opposite of the
// mainstream social-proof move.

const HOUR_MIN = 5
const DAY_MIN = 10

export function SocialProofChip({ activity }) {
  if (!activity) return null
  const { last24h = 0, lastHour = 0, trending = false } = activity

  if (trending) {
    return <span className="badge social-proof trending" title="Recent activity is spiking.">🔥 Trending</span>
  }
  if (lastHour >= HOUR_MIN) {
    return (
      <span className="badge social-proof live" title={`${lastHour} vote${lastHour === 1 ? '' : 's'} in the last hour`}>
        ⚡ {lastHour} voting now
      </span>
    )
  }
  if (last24h >= DAY_MIN) {
    return (
      <span className="badge social-proof today" title={`${last24h} votes in the last 24 hours`}>
        💬 {last24h} today
      </span>
    )
  }
  return null
}
